export const Endpoints = {
    getProductsSku: 'common/getProducts',
    getRetailers: 'common/getRetailers',
    getRetailersByType: 'common/getRetailersByType',
    getRetailersByCountry: 'common/getRetailersByCountry',
    externalCalls: 'common/externalCalls',
    getEntitlements: 'entitlements/get-entitlements',
    getRegistrations: 'registration/get-registrations',
    deleteProduct: 'registration/delete-registration',
    editRegistrationDetails: 'registration/edit-registration',
    getRegistrationDetails: 'registration/get-registration-details',
    uploadProofOfPurchase: 'registration/upload-pop',
    deleteProofOfPurchase: 'registration/delete-pop',
    getUserInformation: 'user/getCCPAdetails',
    deleteUser: 'user/deleteCCPA',
    getAccountDetails: 'user/get-account-details',
    accountTransfer: 'user/account-transfer',
    getActiveCampaignDetails: 'campaign/getActiveCampaigns',
    updateActiveCampaignDetails: 'campaign/updateActiveCampaignDetails',
    getReports: 'reports/getReports',
    getBulkReports: 'reports/getBulkReports',
    generateBulkReports: 'reports/generateBulkReport',
    getProtectionPlans: 'protection-plan/getPlanDetails',
    getProductsByCampaign: 'campaign/getProductsByCampaign',
    triggerS3FileReadCsvProtectionPlan: 'protection-plan/uploadPlan',
    uploadProtectionPlans: 'common/uploadFileToS3',
    getRetailersAndCountryCode: 'retailer/get-RetailersAndCountryCode',
    addRetailer: 'retailer/add-retailer',
    editRetailer: 'retailer/edit-retailer',
    deleteRetailer: 'retailer/delete-retailer',
    exportRetailer: 'retailer/export-retailer',
}